import React from "react";
import { FaqMarkdownPage } from "../../components/FaqMarkdownPage";

// Routed at /faq/certificates — content lives entirely in
// public/locales/faq/certificates-add-freeze.*.md, editable without touching this file.
export const CertificatesFaqPage: React.FC = () => (
    <FaqMarkdownPage
        titleKey="FAQ_CERTIFICATES_TITLE"
        titleFallback="Certificates — Temporary Pause on Adding New Certificates"
        markdownBasePath="/locales/faq/certificates-add-freeze"
    />
);
